import { makeStyles,useTheme } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme=>({
  categoriesMappingWrapper: {
    paddingTop: '40px',
    width: '100%'
  },
  title: {
    margin: '0 0 19px'
  },
  input: {
    paddingTop: '24px',
    width: '180px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  inputRow: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  }
}));
